<template>
  <div class="my-5">
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <div class="card">
            <div class="card-body">
              <h3>Pages</h3>

              <div class="mt-3">
                <ul class="list-inline">

                  <li class="list-inline-item">
                    <router-link to="/">Home Page</router-link>
                  </li>

                  <li class="list-inline-item">
                    <router-link to="/about-us">About Page</router-link>
                  </li>

                  <li class="list-inline-item">
                    <router-link to="/practice-areas">Practice areas Page</router-link>
                  </li>

                  <li class="list-inline-item">
                    <router-link to="/articles">Articles Page</router-link>
                  </li>

                  <li class="list-inline-item">
                    <router-link to="/careers">Careers Page</router-link>
                  </li>

                  <li class="list-inline-item">
                    <router-link to="/contact-us">Contact Page</router-link>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "Sitemap",
    data() {
        return {
            title: "Sitemap"
        };
    },
    metaInfo: {
        title: "Sitemap"
    }
};
</script>



// WEBPACK FOOTER //
// src/views/frontend/Sitemap.vue